import { render } from "./Floor.vue?vue&type=template&id=05005fc2&scoped=true"
import script from "./Floor.vue?vue&type=script&lang=js"
export * from "./Floor.vue?vue&type=script&lang=js"

import "./Floor.vue?vue&type=style&index=0&id=05005fc2&lang=scss&scoped=true"

import exportComponent from "/Users/martin/www/forton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05005fc2"]])

export default __exports__